import React from "react";
import { Modal, Button } from "antd";

export const GlassConfirmModal = ({ open, onCancel, onConfirm }) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      className="glass-theme-modal"
      width={500}
      // maskStyle={{ backdropFilter: "blur(4px)", background: "rgba(0, 0, 0, 0.4)" }}
    >
      <div className="d-flex flex-column align-items-center text-center px-2 py-4">
        <h3 className="text-white fw-bold mb-2" style={{ fontSize: "1.25rem" }}>
          Are you sure you want to finish this test?
        </h3>
        <p className="text-light-gray mb-4" style={{ fontSize: "0.9rem" }}>
          This action is permanent and cannot be undone.
        </p>

        <div className="d-flex gap-3 w-100 mt-2 px-4">
          <Button className="glass-cancel-btn flex-grow-1" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" className="glass-confirm-btn flex-grow-1" onClick={onConfirm}>
            Finish
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export const GlassSuccessModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      className="glass-theme-modal"
      width={550}
      // maskStyle={{ backdropFilter: "blur(4px)", background: "rgba(0, 0, 0, 0.4)" }}
    >
      <div className="d-flex flex-column align-items-center text-center p-4 py-5">
        <img src="/assets/small-questions-logo.png" alt="Nova Logo" height={65} className="mb-4" />
        <h3 className="text-white fw-bold mb-2" style={{ fontSize: "1.4rem" }}>
          Congratulations, You're All Done
        </h3>
        <div className="text-light-gray" style={{ fontSize: "0.95rem", lineHeight: "1.5" }}>
          <div>Thanks for completing the screening.</div>
          <div>Move forward with AI Mock Interview.</div>
        </div>
      </div>
    </Modal>
  );
};
